import { FaCheckCircle, FaRegCircle } from 'react-icons/fa';
import type { KioskRegistrationGate } from '../../types/kioskRegistration.types';

export default function RegistrationGatesList({ gates }: { gates: KioskRegistrationGate[] }) {
  if (!gates?.length) {
    return <p className="text-sm text-gray-500 dark:text-gray-400">No gates apply to this registration.</p>;
  }
  return (
    <ul className="space-y-2">
      {gates.map((gate) => (
        <li key={gate.key} className="flex items-start gap-2 text-sm">
          {gate.satisfied ? (
            <FaCheckCircle className="mt-0.5 shrink-0 text-emerald-600" aria-label="Satisfied" />
          ) : (
            <FaRegCircle className="mt-0.5 shrink-0 text-gray-400" aria-label="Not satisfied" />
          )}
          <div>
            <p className={gate.satisfied ? 'font-medium text-gray-900 dark:text-gray-100' : 'text-gray-700 dark:text-gray-300'}>
              {gate.label}
            </p>
            {gate.detail && <p className="text-xs text-gray-500 dark:text-gray-400">{gate.detail}</p>}
          </div>
        </li>
      ))}
    </ul>
  );
}
